import { render } from "./VehicleIssuesView.vue?vue&type=template&id=3ab26e37"
import script from "./VehicleIssuesView.vue?vue&type=script&lang=js"
export * from "./VehicleIssuesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__